/**
 * @descriptino All Rectangular plugins extend this class. Provides a bunch of util methods
 *
 */
export class FabricRectangular {
    layout;

    points = {};

    constructor(layout) {
        this.layout = layout;
        this.setPoints();
    }

    getRectangularSize() {
        return { width: this.layout.width, height: this.layout.height };
    }

    setPoints(layout) {
        this.layout = { ...this.layout, ...layout };
        const pointA = { x: this.layout.x, y: this.layout.y };
        const pointB = { x: this.layout.x + this.layout.width, y: this.layout.y };
        const pointC = { x: this.layout.x + this.layout.width, y: this.layout.y + this.layout.height };
        const pointD = { x: this.layout.x, y: this.layout.y + this.layout.height };
        this.points = {
            A: pointA, B: pointB, C: pointC, D: pointD
        };
    }

    getRectangularSides() {
        return [
            [this.points.A, this.points.B],
            [this.points.B, this.points.C],
            [this.points.C, this.points.D],
            [this.points.D, this.points.A]
        ];
    }

    getRectangularSidesObject(accountForMargin) {
        const pointA = { ...this.points.A };
        const pointB = { ...this.points.B };
        const pointC = { ...this.points.C };
        const pointD = { ...this.points.D };
        if (accountForMargin) {
            pointA.x -= 1;
            pointA.y -= 1;

            pointB.x += 1;
            pointB.y -= 1;

            pointC.x += 1;
            pointC.y += 1;

            pointD.x -= 1;
            pointD.y += 1;
        }
        return {
            TOP: [pointA, pointB],
            RIGHT: [pointB, pointC],
            BOTTOM: [pointC, pointD],
            LEFT: [pointD, pointA]
        };
    }

    lineIntersectRectSide(line, accountForMargin) {
        const sides = this.getRectangularSidesObject(accountForMargin);
        const sidesKeys = Object.keys(sides);
        for (let i = 0; i < sidesKeys.length; i++) {
            const side = sides[sidesKeys[i]];
            const lineIntersects = this.lineIntersects(
                side[0].x, side[0].y, side[1].x, side[1].y,
                line[0].x, line[0].y, line[1].x, line[1].y
            );
            if (lineIntersects) return sidesKeys[i];
        }
        return false;
    }

    // returns true iff the line from (a,b)->(c,d) intersects with (p,q)->(r,s)
    lineIntersects(a, b, c, d, p, q, r, s) {
        let det; let gamma; let
            lambda;
        det = (c - a) * (s - q) - (r - p) * (d - b);
        if (det === 0) {
            return false;
        }
        lambda = ((s - q) * (r - a) + (p - r) * (s - b)) / det;
        gamma = ((b - d) * (r - a) + (c - a) * (s - b)) / det;
        return (lambda > 0 && lambda < 1) && (gamma > 0 && gamma < 1);
    }

    // return true if the rectangle and circle are colliding
    rectCircleColliding(circle, rect) {
        return circle.x + circle.radius > rect.x
            && circle.x - circle.radius < (rect.x + rect.width)
            && circle.y + circle.radius > rect.y
            && circle.y - circle.radius < (rect.y + rect.height);
    }

    pointInRect(point, rectPoints) {
        if (!rectPoints) rectPoints = this.points;
        const verticalInside = point.y > rectPoints.A.y && point.y < rectPoints.D.y;
        const horizontalInside = point.x > rectPoints.A.x && point.x < rectPoints.B.x;
        return verticalInside && horizontalInside;
    }

    // Function to check intercept of line seg and circle
    // A,B end points of line segment
    // C center of circle
    // radius of circle
    // returns true if touching or crossing else false
    doesLineInterceptCircle(A, B, C, radius) {
        let dist;
        const v1x = B.x - A.x;
        const v1y = B.y - A.y;
        const v2x = C.x - A.x;
        const v2y = C.y - A.y;
        // get the unit distance along the line of the closest point to
        // circle center
        const u = (v2x * v1x + v2y * v1y) / (v1y * v1y + v1x * v1x);

        // if the point is on the line segment get the distance squared
        // from that point to the circle center
        if (u >= 0 && u <= 1) {
            dist = (A.x + v1x * u - C.x) ** 2 + (A.y + v1y * u - C.y) ** 2;
        } else {
            // if closest point not on the line segment
            // use the unit distance to determine which end is closest
            // and get dist square to circle
            dist = u < 0
                ? (A.x - C.x) ** 2 + (A.y - C.y) ** 2
                : (B.x - C.x) ** 2 + (B.y - C.y) ** 2;
        }
        return dist < radius * radius;
    }

    // rectCircleColliding(circle, rect) {
    //     let distX = Math.abs(circle.x - rect.x - rect.width / 2);
    //     let distY = Math.abs(circle.y - rect.y - rect.height / 2);

    //     if (distX > (rect.w / 2 + circle.radius)) { return false; }
    //     if (distY > (rect.h / 2 + circle.radius)) { return false; }

    //     if (distX <= (rect.width / 2)) { return true; }
    //     if (distY <= (rect.height / 2)) { return true; }

    //     let dx = distX - rect.width / 2;
    //     let dy = distY - rect.height / 2;
    //     return (dx * dx + dy * dy <= (circle.radius * circle.radius));
    // }
}
